const indexData = [
  { icon: 'ri-fire-line', color: 'text-accent-500', bg: 'bg-accent-100', title: '热播榜单', desc: '实时热度排行，最火剧集一网打尽', href: '#ranking' },
  { icon: 'ri-movie-2-line', color: 'text-primary-500', bg: 'bg-primary-100', title: '国产剧专区', desc: '大陆热剧每日同步更新，高分好剧看不停', href: '#cards' },
  { icon: 'ri-earth-line', color: 'text-secondary-500', bg: 'bg-secondary-100', title: '海外剧频道', desc: '韩剧美剧日剧泰剧，全球好剧尽在其中', href: '#media' },
  { icon: 'ri-calendar-check-line', color: 'text-accent-500', bg: 'bg-accent-100', title: '每日更新日历', desc: '追剧不迷路，每日更新剧集时间表一目了然', href: '#updates' },
  { icon: 'ri-heart-pulse-line', color: 'text-primary-500', bg: 'bg-primary-100', title: '高分口碑榜', desc: '豆瓣8分以上的口碑神剧，品质保证不踩雷', href: '#ranking' },
  { icon: 'ri-compass-3-line', color: 'text-secondary-500', bg: 'bg-secondary-100', title: '新用户指南', desc: '第一次来香蕉影视？从这里开始你的追剧之旅', href: '#faq' },
  { icon: 'ri-star-smile-line', color: 'text-accent-500', bg: 'bg-accent-100', title: '编辑精选', desc: '主编团队倾情推荐，每一部都值得细细品味', href: '#carousel' },
];

export default function Index() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">追剧指南</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">快速找到你想看的内容，七大入口帮你精准定位好剧</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <a
              key={i}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
              className={`flex items-start gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group ${i === 0 ? 'lg:col-span-2' : ''}`}
            >
              <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.bg} ${item.color} flex-shrink-0 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading text-base text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}